import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconFlipHorizontal: React.FC<IconProps> = ({
    width = 14,
    height = 14,
    color = '#303030',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
        >
            <g clip-path="url(#clip0_6109_13830)">
                <path d="M0 12.5L5 8.33333L0 4.25V12.5Z" fill={color} />
                <path
                    d="M7.5 8.41406L12.5 12.4974V4.16406L7.5 8.41406ZM11.6667 10.7474L8.83333 8.41406L11.6667 5.91406V10.7474Z"
                    fill={color}
                />
                <path d="M5.83301 4.16406H6.66634V4.9974H5.83301V4.16406Z" fill={color} />
                <path d="M5.83301 2.5H6.66634V3.33333H5.83301V2.5Z" fill={color} />
                <path d="M5.83301 5.83203H6.66634V6.66536H5.83301V5.83203Z" fill={color} />
                <path d="M5.83301 7.5H6.66634V8.33333H5.83301V7.5Z" fill={color} />
                <path d="M5.83301 9.16406H6.66634V9.9974H5.83301V9.16406Z" fill={color} />
                <path d="M5.83301 10.832H6.66634V11.6654H5.83301V10.832Z" fill={color} />
                <path d="M5.83301 12.5H6.66634V13.3333H5.83301V12.5Z" fill={color} />
                <path
                    d="M6.24935 0.833333C7.33268 0.833333 8.41602 1.41667 9.24935 2.41667L8.33268 3.33333H10.8327V0.833333L9.83268 1.83333C8.83268 0.666667 7.58268 0 6.24935 0C4.66602 0 3.24935 0.833333 2.16602 2.41667L2.83268 2.91667C3.74935 1.58333 4.91602 0.833333 6.24935 0.833333Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_6109_13830">
                    <rect width="13.3333" height="13.3333" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconFlipHorizontal;
